import { LuPlus } from 'react-icons/lu';
import { ChangePlanModal } from '@/features/subscriptions/components/ChangePlanModal';
import { EmptyStateLayout } from './EmptyStateLayout';
import { useEmptyStateActions } from '../hooks/useEmptyStateActions';
import { BUTTON_LABELS, BUTTON_NAMES, EMPTY_STATE_CONTENT, ROUTES } from '../constants';

import BroadcastEmptyImage from '@/assets/images/broadcast-empty.svg';
import { StanIcon } from '@/components/core-components/types';

interface BroadcastEmptyStateProps {
    variant: 'upgrade' | 'send-email';
    icon?: StanIcon;
}

/**
 * Empty state for the Broadcasts tab
 * Shows different content based on whether user has email-flows module access
 * Matches Vue implementation: vue/src/pages/flows/components/onboarding/BroadcastEmptyState.vue
 */
export const BroadcastEmptyState = ({ variant, icon }: BroadcastEmptyStateProps) => {
    const isUpgradeVariant = variant === 'upgrade';
    const { handleButtonClick, isModalOpen, setIsModalOpen } = useEmptyStateActions({
        variant: isUpgradeVariant ? 'upgrade' : 'action',
        actionRoute: ROUTES.NEW_BROADCAST,
    });

    const buttonName = BUTTON_NAMES.BROADCAST_EMPTY_STATE;
    const buttonLabel = isUpgradeVariant ? BUTTON_LABELS.UPGRADE_TO_PRO : BUTTON_LABELS.SEND_EMAIL;
    const buttonIcon = isUpgradeVariant ? <LuPlus /> : icon;

    const content = EMPTY_STATE_CONTENT.BROADCASTS;

    return (
        <>
            <EmptyStateLayout
                title={content.title}
                description={content.description}
                bulletPoints={content.bulletPoints}
                buttonText={buttonLabel}
                buttonIcon={buttonIcon}
                buttonName={buttonName}
                onButtonClick={handleButtonClick}
                illustration={BroadcastEmptyImage}
                imageAlt='Broadcast illustration'
            />

            {/* Change Plan Modal */}
            <ChangePlanModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};
